import { DoctorRepository } from 'repository/interfaces/doctor-repository'
import { FinishDoctorRecommendation } from '../../../domain/usecases/doctor/finish-doctor-recommendation'

export class RemoteFinishDoctorRecommendation
  implements FinishDoctorRecommendation
{
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  finishDoctorRecommendation(
    params: FinishDoctorRecommendation.Params
  ): Promise<FinishDoctorRecommendation.Model> {
    return this.doctorRepository.finishDoctorRecommendation(params)
  }
}

export type FinishDoctorRecommendationModel = FinishDoctorRecommendation.Model
